import Typography from '@material-ui/core/Typography';
import { Warning } from '@material-ui/icons';
import { useFormikContext } from 'formik';
import React from 'react';
import { CurrencyId } from 'v2/interfaces/financial';

import type { INewAccount } from 'v2/interfaces/financial';

import { useStyles } from './styles';

const Resume = () => {
  const { values } = useFormikContext<INewAccount>();

  const classes = useStyles();

  const accountWithDigit = () => `${values.account || ''}${values.account_digit ? `-${values.account_digit}` : ''}`;
  const agencyWithDigit = () => `${values.agency || ''}${values.agency_digit ? `-${values.agency_digit}` : ''}`;

  function getAccountType(type: string) {
    const accountTypes = {
      CC: 'Conta Corrente',
      CP: 'Conta Poupança',
    };

    return accountTypes[type] || '';
  }

  const accountType = getAccountType(values.type);
  const isBRLSelected = values.currency === CurrencyId.BRL;
  const shouldDisplayAccountType = accountType && isBRLSelected;

  return (
    <div className={classes.content}>
      <div>
        <Typography className={classes.title}>{values.name}</Typography>

        <Typography className={classes.currency}>{isBRLSelected ? 'BRL' : 'USD'}</Typography>

        <div className={classes.mt8} />

        <Typography>Banco: {values.bank_id || ''}</Typography>

        {values.operation_id !== 'not-selected' && values.operation_id && <Typography>Operação: {values.operation_id || ''}</Typography>}

        <Typography>Agência: {agencyWithDigit()}</Typography>

        <Typography>Conta: {accountWithDigit()}</Typography>

        {shouldDisplayAccountType && <Typography>Tipo de conta: {accountType}</Typography>}
      </div>

      <div className='m16'></div>
      <div className={classes.alert}>
        <Warning classes={{ root: classes.icon }} />
        <Typography className={classes.attentionText}>
          Ao clicar em finalizar você receberá um e-mail de confirmação que deve ser validado para conclusão do seu cadastro. Caso tenha alguma dúvida
          é só nos chamar no chat do menu de ajuda ou entrar em contato em <b>suporte@eduzz.com</b>.
        </Typography>
      </div>
    </div>
  );
};
export default Resume;
